import CryptoJS from "crypto-js";

export const Encrypt = (payload) => {
    const plaintext = JSON.stringify(payload);
    const secretKeyHex = process.env.REACT_APP_SECRET_KEY;
    const ivHex = process.env.REACT_APP_IV;

    const key = CryptoJS.enc.Hex.parse(secretKeyHex);
    const iv = CryptoJS.enc.Hex.parse(ivHex);

    const encrypted = CryptoJS.AES.encrypt(plaintext, key, { iv: iv });
    const encryptedBase64 = encrypted.toString();

    console.log("Encrypted Data (Base64):", encryptedBase64);
    return JSON.stringify({ data: encryptedBase64 })
}

export default Encrypt;